import React, { Props, Component, Fragment } from 'react';



class DayTourItinery extends Component {

	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div className="day-lis">
				
				{this.props.itinery !== null ? this.props.itinery.map((item,i)=>{
					return <div key={"it-"+i} className="day time-ro">
					<p>{item.summery}</p>
				</div>;
				}):null}
				
				

			</div>
		);
	}
}

DayTourItinery.defaultProps = {
	home: false,
}


export default (DayTourItinery);